import searchInterface from '../../interfaces/api/search';
import {
  getResult,
  getResultF,
  getResultS,
  invalidateResult,
} from '../slices/search';
import { setErrorThunk } from './modals';

export const getResultThunk = (query) => async (dispatch) => {
  dispatch(getResult());

  await searchInterface
    .getResult(query)
    .then((response) => {
      dispatch(getResultS(response));
    })
    .catch((err) => {
      dispatch(getResultF());

      console.log(err);
      dispatch(
        setErrorThunk(
          'Die ausgewählte Praxis konnte nicht abgerufen werden. Versuchen Sie es später erneut.',
          err,
        ),
      );
    });
};

export const invalidateResultThunk = () => async (dispatch) => {
  dispatch(invalidateResult());
};
